import BaseController from "vamos/cockpit/base/controller/type/BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ResponseImportStatusDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import getText from "vamos/cockpit/base/handler/Text";
import StringUtil from "vamos/cockpit/base/util/StringUtil";

export default class MaintenanceService {
    private running = false;

    private interval: null;

    private controller: BaseController;

    public constructor(controller: BaseController) {
        this.controller = controller;
    }

    public async checkMaintenanceStatus(callbackFunction = () => {
    }): Promise<void> {
        const importStatus: ResponseImportStatusDto = await ApiService.getInstance().getRestJsonData("/import/masterdata/status");

        const appModel = this.controller.getModel("app") as JSONModel;
        if (importStatus.content) {
            appModel.setProperty("/maintenance", true);
            this.runMaintenance(callbackFunction);
        } else {
            appModel.setProperty("/maintenance", false);
        }
    }

    public runMaintenance(finishedCallback = () => {
    }) {
        if (this.running) {
            return;
        }
        this.running = true;

        const oStatusInterval = setInterval(() => {
            ApiService.getInstance().getRestJsonData("/import/masterdata/status")
                .then((response) => this.statusUpdate(response, finishedCallback)).catch(() => clearInterval(oStatusInterval));
        }, 1000);
        const viewModel = this.controller.getViewModel();
        viewModel.setProperty("/noBusyIndicator", true);
    }

    private statusUpdate(response: ResponseImportStatusDto, callbackFunction = () => {
    }) {
        const responseContent = response.content;
        const oAppModel = this.controller.getModel("app") as JSONModel;

        if (!responseContent) {
            clearInterval(this.interval);
            const appModel = this.controller.getModel("app") as JSONModel;
            appModel.setProperty("/maintenance", false);
            this.controller.refreshWholeModel();
            this.running = false;

            if (callbackFunction) {
                callbackFunction();
            }
            return;
        }

        let sStepText = getText("BmeCatProgressText", [responseContent.currentEntry, responseContent.totalStepEntries]);

        if (responseContent.currentStep === "WRITE_TO_DB") {
            sStepText = getText("BmeCatWriteProgressText", [responseContent.currentEntry, responseContent.totalStepEntries]);
        } else if (responseContent.currentStep === "INIT_PRODUCT_IMPORT") {
            sStepText = getText("BmeCatInitImportProgressText", [responseContent.currentEntry, responseContent.totalStepEntries]);
        }

        const stepProgressText = getText("StepProgressText", [responseContent.currentStepCount, responseContent.maxStepCount]);

        let sCurrentStepPraefix;
        if (!StringUtil.checkUpperCase(responseContent.currentStep)) {
            sCurrentStepPraefix = responseContent.currentStep;
        } else {
            sCurrentStepPraefix = getText("MASTER_DATA_STATUS_" + responseContent.currentStep);
        }

        oAppModel.setProperty("/CurrentStep", sCurrentStepPraefix + " (" + stepProgressText + ")");
        oAppModel.setProperty("/StepPercentage", responseContent.stepPercentage);
        oAppModel.setProperty("/StepText", sStepText);
    };
}
